import { EditButton, TopToolbar, useGetIdentity, useRedirect } from 'react-admin'

const MailTextShowActions = () => {
  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <TopToolbar sx={{justifyContent:"flex-start"}}>
      <EditButton onClick={(e) => {
        e.preventDefault()
        redirect(`/users/${identity.id}/mailServiceConfig/edit/1`)
      }}/>
    </TopToolbar>
  )
}

export default MailTextShowActions